// adding some validations logic for user login form
import { required, email, minLength } from 'vuelidate/lib/validators'

export const FORM_SIGNIN = {
  userDataForm: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formLogin.js